import React from 'react';
import { Text } from 'react-native';

const IconText = ({ children }) => (
  <Text style={{
    fontSize: 12,
    margin: 'auto',
  }}
  >
    {children}
  </Text>
);
export default IconText;
